module.exports = __webpack_public_path__ + "static/media/ic_bankpay.af7bc3e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_bankpay.svg
// module id = 286
// module chunks = 0